<template>
  <section class="makingof-video-home">
    <div class="container">
      <h2 v-if="sectionTitle" class="section-title">{{ sectionTitle }}</h2>
      <ClientOnly>
        <Carousel v-model="currentSlide" v-bind="settings">
          <Slide v-for="(post, index) in posts" :key="post.id">
            <MakingofVideoSlide :post="post" :active="index === currentSlide" />
          </Slide>
          <template #addons v-if="posts.length > 1">
            <Navigation />
          </template>
        </Carousel>
      </ClientOnly>
      <div class="row d-flex align-items-center justify-content-center">
        <button
          type="button"
          class="more-blog mt-5 mb-5 p-3 col-lg-5 col-11"
          @click="redirect"
        >
          <template v-if="seeAllHighlight">
            {{ seeAllPrefix }} <strong class="see-all-highlight">{{ seeAllHighlight }}</strong>
          </template>
          <template v-else>
            {{ seeAllLabel }}
          </template>
          <font-awesome :icon="['fas', 'arrow-right']" class="more-blog__arrow" />
        </button>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import MakingofVideoSlide, { type MakingOfPost } from "@/components/HomePage/MakingofVideoSlide.vue";

const props = withDefaults(
  defineProps<{
    posts: MakingOfPost[];
    seeAllLabel: string;
    seeAllRouteName?: string;
    sectionTitle?: string;
    seeAllPrefix?: string;
    seeAllHighlight?: string;
  }>(),
  {
    seeAllRouteName: "language-lives",
    sectionTitle: "",
    seeAllPrefix: "",
    seeAllHighlight: "",
  }
);

const route = useRoute();
const router = useRouter();

const settings = ref({
  itemsToShow: 1,
  itemsToScroll: 1,
  snapAlign: "center" as const,
});

const currentSlide = ref(0);

function redirect() {
  router.push({
    name: props.seeAllRouteName,
    params: { language: route.params.language },
  });
}
</script>

<style scoped lang="css">
.section-title {
  display: none;
}
.see-all-highlight {
  font-weight: 700;
}

/* setas de navegação (desktop e mobile): a cor padrão do vue3-carousel é preta
   e some no fundo escuro; brancas e acima do overlay .play-icon (z-index: 1) do
   slide. Sem inset-block-start: o default da lib (50% + translateY) centra no vídeo. */
:deep(.carousel__prev),
:deep(.carousel__next) {
  width: 44px;
  height: 44px;
  color: #ffffff;
  z-index: 2;
  transition: background 0.3s ease;
}
:deep(.carousel__icon) {
  width: 34px;
  height: 34px;
}

/* regras desktop: título visível à esquerda e branco */
@media screen and (min-width: 770px) {
  .section-title {
    display: block;
    text-align: left;
    color: #ffffff;
    font-family: "Bebas-Neue-Light";
    font-size: 64px;
    font-weight: 300;
    line-height: 1.1;
    letter-spacing: 0;
    text-transform: uppercase;
    margin: 0 0 16px;
    padding-top: 8px;
    padding-left: 12px;
  }
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .section-title {
    display: block;
    text-align: center;
    color: #ffffff;
    font-family: "Bebas-Neue-Light";
    font-size: 40px;
    line-height: 1.1;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin: 0 0 16px;
    padding-top: 8px;
  }

  /* gutter lateral: estreita o vídeo para as setas caberem AO LADO dele
     (as setas absolutas da lib, em inset 0, caem dentro do padding) */
  :deep(.carousel__prev),
  :deep(.carousel__next) {
    width: 34px;
    height: 34px;
  }
  :deep(.carousel__icon) {
    width: 26px;
    height: 26px;
  }

}

/* regras mobile 769vp */
@media screen and (max-width: 1362px) {

  :deep(.carousel) {
    padding: 0 15px;
  }

  :deep(.carousel__prev) {
    left: -25px;
  }

  :deep(.carousel__next) {
    right: -25px;
  }

}

.more-blog {
  font-family: "Exo-2";
  font-size: 16px !important;
  font-weight: 400;
  background-color: #000000 !important;
  border: 1px solid #ffffff !important;
  border-radius: 30px !important;
  color: white;
}

.more-blog svg {
  color: #ffffff;
  margin-left: 8px;
}

.more-blog svg.more-blog__arrow {
  color: #b20000; /* arrow vermelha (sobrescreve o branco da regra svg) */
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .more-blog__arrow {
    display: none;
  }
  .more-blog {
    width: 260px !important;
  }
}
</style>
